import { useEffect, useCallback } from 'react';
import { messaging, getToken, onMessage } from '../services/firebase';
import { db } from '../services/firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import toast from 'react-hot-toast';

const VAPID_KEY = 'BBxliB_UQlJi1TDmbV1kMUyeZrd4e1NwnWby5CXqDtVyTRJxlo3--PscEV7Qfg-hHC2xJOi21qDfPgLiTdjkRHQ';

const usePushNotifications = (user) => {
  const saveFCMToken = useCallback(async (token) => {
    if (!user?.uid) return;
    try {
      await setDoc(doc(db, 'users', user.uid, 'tokens', 'fcm'), {
        token,
        updatedAt: serverTimestamp(),
        platform: navigator.userAgent.includes('Mobile') ? 'mobile' : 'web',
        email: user.email
      }, { merge: true });
    } catch (e) {
      console.error('Error saving FCM token:', e);
    }
  }, [user]);

  const requestPermission = useCallback(async () => {
    if (!messaging) return null;
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: await navigator.serviceWorker.ready
        });
        if (token) {
          await saveFCMToken(token);
          return token;
        }
      }
    } catch (e) {
      console.error('Error getting FCM token:', e);
    }
    return null;
  }, [saveFCMToken]);

  // Listen for foreground messages
  useEffect(() => {
    if (!messaging || !user?.uid) return;

    const unsubscribe = onMessage(messaging, (payload) => {
      const { title, body } = payload.notification || {};
      const data = payload.data || {};

      if (data.type === 'call') {
        // Dispatch call event to app
        window.dispatchEvent(new CustomEvent('incoming-call', { detail: data }));
        toast(
          (t) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>📞</span>
              <div>
                <strong>{title || 'Llamada entrante'}</strong>
                <p style={{ margin: 0, fontSize: '12px' }}>{body}</p>
              </div>
            </div>
          ),
          { duration: 30000, icon: '📞' }
        );
      } else {
        // Regular message notification
        toast(body || title || 'Nuevo mensaje', {
          icon: '💬',
          duration: 4000,
          style: { borderRadius: '12px', padding: '12px 16px' }
        });
      }
    });

    return () => unsubscribe();
  }, [user]);

  // Auto-request on mount
  useEffect(() => {
    if (user?.uid && messaging) {
      requestPermission();
    }
  }, [user, requestPermission]);

  return { requestPermission };
};

export default usePushNotifications;
